@if (description()) {
    <span class="ap-input__description" data-testid="description" [attr.id]="uniqueId + '-description'">
        {{ description() }}
    </span>
}

<ng-content select="ap-context-explanation"></ng-content>

@if (helpTextPosition() === HelpTextPosition.ABOVE && helpText()) {
    <ng-container *ngTemplateOutlet="helpTextElement; context: { above: true }"></ng-container>
}

<div class="ap-input__container" #container>
    <label class="ap-input__wrapper" data-testid="wrapper">
        <span class="ap-input__label" data-testid="label" [attr.id]="uniqueId + '-label'">{{ label() }}</span>
        @if (prefix()) {
            <span class="ap-input__prefix" data-testid="prefix" [innerHTML]="prefix()"></span>
        }
        <input
            #input
            class="ap-input__input"
            data-testid="input"
            [disabled]="isDisabled ? isDisabled : null"
            [attr.inputmode]="inputmode() ? inputmode() : null"
            [attr.type]="type()"
            [attr.maxlength]="maxlength() ? maxlength() : null"
            [attr.aria-required]="isRequired ? isRequired : null"
            [attr.aria-describedby]="ariaDescribedBy"
            [attr.aria-invalid]="control ? control.invalid : null"
            [attr.value]="valueDisplay"
            [value]="valueDisplay"
            [(ngModel)]="valueDisplay"
            (input)="onInputChange($event)"
            (blur)="onBlur()"
            (search)="onSearch($event)"
            (keydown.enter)="onSearch($event); $event.preventDefault()"
            [attr.autocomplete]="autocomplete() ? autocomplete() : 'off'"
            apAutocompleteInputRef
            [apAutocomplete]="auto"
            [apAutocompleteDisabled]="!options() || autocomplete() !== 'off'"
            [connectedElement]="connectedElement"
        />
    </label>
    @if (icon()) {
        <button
            class="ap-input__button"
            [disabled]="isDisabled ? isDisabled : null"
            [attr.aria-labelledby]="uniqueId + '-label'"
            (click)="handleIconClick($event)"
            data-testid="button"
        >
            <ap-icon [name]="icon()" [size]="'large'" [color]="isDisabled ? 'disabled' : 'inherit'" data-testid="icon"></ap-icon>
        </button>
    }
</div>

@if (suggestionValue) {
    <ap-suggestion
        class="ap-input__suggestion"
        [suggestion]="suggestionValue"
        (onClick)="applySuggestion()"
        data-testid="suggestion"
    ></ap-suggestion>
} @else if (helpTextPosition() === HelpTextPosition.BELOW && helpText()) {
    <ng-container *ngTemplateOutlet="helpTextElement"></ng-container>
}

@if (control) {
    <ap-form-errors
        data-testid="errors"
        [control]="control"
        [messages]="messages()"
        [content]="content"
        [attr.id]="uniqueId + '-errors'"
    ></ap-form-errors>
}

<ap-autocomplete-panel
    #auto="apAutocomplete"
    [autocompleteOptions]="options()"
    (optionSelected)="optionSelect($event)"
    data-testid="autocomplete"
>
    @if (options()) {
        @for (option of filteredOptions; track $index; let i = $index) {
            <ap-autocomplete-option
                [value]="option"
                [labels]="filterService.getLabelOption(option, options(), optionKey())"
                [searchTerm]="value"
            ></ap-autocomplete-option>
        }
    }
</ap-autocomplete-panel>

<ng-template #helpTextElement let-above="above">
    <div
        class="ap-input__help-text {{ above ? 'ap-input__help-text--above' : 'ap-input__help-text--below' }}"
        data-testid="help-text"
        [attr.id]="uniqueId + '-help-text'"
        [innerHTML]="helpText()"
    ></div>
</ng-template>
